var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"home-layout"}},[_c('NavbarItem'),_c('div',{staticClass:"pages-container"},[_c('router-view')],1),_c('FooterItem')],1)}
var staticRenderFns = []

export { render, staticRenderFns }